module.exports = __webpack_public_path__ + "img/selected.6c8025db.svg";